module.exports = __webpack_public_path__ + "img/superAceX.2e688a9c.jpeg";